<template>
  <div>

    <v-row>
      <v-col class="pb-0">
        <svg @mouseenter="hovered = true" @mouseleave="hovered = false"
          :width="width" :height="height" viewBox="0 0 128 128" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2_1229)">
            <path
              d="M20.45 98.35C19.62 98.35 18.95 97.68 18.95 96.85V75.83C18.95 75 19.62 74.33 20.45 74.33C21.28 74.33 21.95 75 21.95 75.83V96.85C21.95 97.68 21.28 98.35 20.45 98.35Z"
              fill="#E8EEEA" />
            <path
              d="M26.01 104.22C25.18 104.22 24.51 103.55 24.51 102.72V81.7C24.51 80.87 25.18 80.2 26.01 80.2C26.84 80.2 27.51 80.87 27.51 81.7V102.72C27.51 103.55 26.84 104.22 26.01 104.22Z"
              fill="#E8EEEA" />
            <path
              d="M50.32 102.12C71.6437 102.12 88.93 84.8337 88.93 63.51C88.93 42.1863 71.6437 24.9 50.32 24.9C28.9962 24.9 11.71 42.1863 11.71 63.51C11.71 84.8337 28.9962 102.12 50.32 102.12Z"
              :fill="c_base_color" />
            <g :class="{ hovered: hovered }">
              <path
                d="M64 18.97C66.11 18.97 68.21 19.77 69.81 21.37L108.62 60.18C111.82 63.38 111.82 68.61 108.62 71.81L69.81 110.62C68.21 112.22 66.1 113.02 64 113.02C61.9 113.02 59.79 112.22 58.19 110.62L19.38 71.81C16.18 68.61 16.18 63.38 19.38 60.18L58.19 21.36C59.79 19.76 61.9 18.96 64 18.96M64 16.13C61.04 16.13 58.27 17.28 56.18 19.36L17.38 58.17C13.07 62.48 13.07 69.49 17.38 73.8L56.19 112.61C58.27 114.69 61.05 115.84 64.01 115.84C66.97 115.84 69.74 114.69 71.83 112.61L110.64 73.8C114.95 69.49 114.95 62.48 110.64 58.17L71.83 19.36C69.75 17.28 66.97 16.13 64.01 16.13H64Z"
                fill="#0A863C" />
              <path
                d="M58.1944 21.3546L19.3813 60.1677C16.1712 63.3778 16.1712 68.5824 19.3813 71.7925L58.1944 110.606C61.4045 113.816 66.6091 113.816 69.8192 110.606L108.632 71.7925C111.842 68.5824 111.842 63.3778 108.632 60.1677L69.8192 21.3546C66.6091 18.1445 61.4045 18.1445 58.1944 21.3546Z"
                fill="#D0F4DB" />
              <path
                d="M64 20.86C65.7 20.86 67.29 21.52 68.48 22.7L107.29 61.51C108.48 62.7 109.13 64.29 109.13 65.99C109.13 67.69 108.47 69.28 107.29 70.47L68.48 109.28C67.29 110.47 65.7 111.12 64 111.12C62.3 111.12 60.71 110.46 59.52 109.28L20.71 70.47C19.52 69.28 18.87 67.69 18.87 65.99C18.87 64.29 19.53 62.7 20.71 61.51L59.52 22.7C60.71 21.51 62.3 20.86 64 20.86ZM64 18.97C61.89 18.97 59.79 19.77 58.19 21.37L19.38 60.17C16.18 63.37 16.18 68.6 19.38 71.8L58.19 110.61C59.79 112.21 61.9 113.01 64 113.01C66.1 113.01 68.21 112.21 69.81 110.61L108.62 71.8C111.82 68.6 111.82 63.37 108.62 60.17L69.81 21.36C68.21 19.76 66.1 18.96 64 18.96V18.97Z"
                fill="white" />
              <path
                d="M89.0201 112.5C102.523 112.5 113.47 101.553 113.47 88.05C113.47 74.5466 102.523 63.6 89.0201 63.6C75.5167 63.6 64.5701 74.5466 64.5701 88.05C64.5701 101.553 75.5167 112.5 89.0201 112.5Z"
                fill="#E28888" />
              <path
                d="M89.0201 113C75.2601 113 64.0701 101.81 64.0701 88.05C64.0701 74.29 75.2601 63.1 89.0201 63.1C102.78 63.1 113.97 74.29 113.97 88.05C113.97 101.81 102.78 113 89.0201 113ZM89.0201 64.1C75.8101 64.1 65.0701 74.84 65.0701 88.05C65.0701 101.26 75.8101 112 89.0201 112C102.23 112 112.97 101.26 112.97 88.05C112.97 74.84 102.23 64.1 89.0201 64.1Z"
                fill="white" />
              <path
                d="M89.02 63.6C102.52 63.6 113.47 74.55 113.47 88.05C113.47 101.55 102.52 112.5 89.02 112.5C75.52 112.5 64.57 101.55 64.57 88.05C64.57 74.55 75.52 63.6 89.02 63.6ZM89.02 60.78C73.98 60.78 61.75 73.01 61.75 88.05C61.75 103.09 73.98 115.32 89.02 115.32C104.06 115.32 116.29 103.09 116.29 88.05C116.29 73.01 104.06 60.78 89.02 60.78Z"
                fill="white" />
              <path
                d="M89.0199 95C87.1499 95 85.6299 96.52 85.6299 98.39C85.7999 102.88 92.2299 102.88 92.3999 98.39C92.3999 96.52 90.8799 95 89.0099 95H89.0199Z"
                fill="white" />
              <path
                d="M92.4099 75.91C90.7299 73.83 87.3199 73.82 85.6399 75.91C84.7999 76.91 84.4399 78.23 84.6699 79.52C85.3399 83.36 86.2899 88.79 86.7199 91.23C87.1999 93.79 90.8499 93.79 91.3299 91.23L93.3799 79.52C93.6099 78.23 93.2499 76.92 92.4099 75.91Z"
                fill="white" />
              <path
                d="M95.8899 34.9C95.0599 34.9 94.3899 34.23 94.3899 33.4V12.39C94.3899 11.56 95.0599 10.89 95.8899 10.89C96.7199 10.89 97.3899 11.56 97.3899 12.39V33.41C97.3899 34.24 96.7199 34.91 95.8899 34.91V34.9Z"
                fill="#E8EEEA" />
              <path
                d="M101.46 40.78C100.63 40.78 99.96 40.11 99.96 39.28V18.26C99.96 17.43 100.63 16.76 101.46 16.76C102.29 16.76 102.96 17.43 102.96 18.26V39.28C102.96 40.11 102.29 40.78 101.46 40.78Z"
                fill="#E8EEEA" />
              <path d="M17.94 48.72L9.01001 48.39L14.1 56.24L17.94 48.72Z"
                fill="#0A863C" />
              <path
                d="M23.5301 52.5L39.5301 48.32L32.7301 59.38L39.9001 66.38L29.4501 70.15L44.5601 80.15L26.5001 79.66L15.3201 68.25L18.0601 57.98L23.5301 52.5Z"
                fill="#0A863C" />
              <path d="M11.25 78.43L13.88 86.98L19.62 79.58L11.25 78.43Z"
                fill="#0A863C" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_2_1229">
              <rect width="128" height="128" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-5">
        <span class="font-weight-medium" :style="[cp_font_size]">
          {{ $t('buttons.eco_visual_condition_damages') }}</span>
      </v-col>
    </v-row>

  </div>
</template>

<script>

export default {
  name: "EcoVisualConditionDamages",
  props: {
    selected: { type: Boolean, required: false },
    height: { type: Number, required: 200 },
    width: { type: Number, required: 180 },
    font_size: { type: String, required: '15px' },

    base_color: { type: String, required: true },
    base_hovered_color: { type: String, required: true },
    base_selected_color: { type: String, required: true },

    base_border_color: { type: String, required: true },
    base_border_hovered_color: { type: String, required: true },
    base_border_selected_color: { type: String, required: true },

  },
  data() {
    return {
      hovered: false
    }
  },
  computed: {
    cp_font_size() {
      return `font-size: ${this.font_size}`
    },
    c_base_color() {
      let color = this.base_color
      if (this.selected) {
        color = this.base_selected_color
      } else {
        if (this.hovered) color = this.base_hovered_color
      }
      return color
    },
    c_base_border_color() {
      let color = this.base_border_color
      if (this.selected) {
        color = this.base_border_selected_color
      } else {
        if (this.hovered) color = this.base_border_hovered_color
      }
      return color
    }
  }
}
</script>

<style scoped></style>